//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import leftLabelList from "@/components/management/label/leftLabelList";
import addLabel from "@/components/management/label/addLabel";
import editLabel from "@/components/management/label/editLabel";
import memberList from "@/components/management/label/memberList";
export default {
  name: "Label",
  components: {
    leftLabelList: leftLabelList,
    addLabel: addLabel,
    editLabel: editLabel,
    memberList: memberList
  },
  props: [],
  data: function data() {
    return {
      curComp: "memberList"
    };
  },
  computed: {},
  mounted: function mounted() {},
  methods: {
    saveSuccess: function saveSuccess() {
      this.$refs.leftLabelList.getLabelListFn();
    },
    leftLabelClick: function leftLabelClick(type, item) {
      var _this = this;

      switch (type) {
        case "addLabel":
          this.curComp = type;
          break;

        case "editLabel":
          this.curComp = type;
          this.$nextTick(function () {
            _this.$refs.curCompRef.setId(item.labelId);
          });
          break;

        case "del":
          break;

        case "memberList":
          this.curComp = type;
          this.$nextTick(function () {
            _this.$refs.curCompRef.loadListFn(item);
          });
          break;

        default:
      }
    },
    goBack: function goBack(item) {
      var _this2 = this;

      this.curComp = "memberList";
      this.$nextTick(function () {
        _this2.$refs.curCompRef.loadListFn(item);
      });
    },
    openDetail: function openDetail(labelId) {
      var _this3 = this;

      this.curComp = "editLabel";
      this.$nextTick(function () {
        _this3.$refs.curCompRef.setId(labelId);
      });
    }
  },
  watch: {},
  filters: {}
};